import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './components/pages/Home'
import Solutions from './components/pages/Solutions'
import Contact from './components/pages/Contact'
import Portfolio from './components/pages/Portfolio'
import Mentions from './components/pages/Mentions'
import Services from './components/pages/Services'
import PriseBrief from './components/pages/PriseBrief'

import Reucirs from './components/pages/portfolios/Reucirs'
import Jmcars from './components/pages/portfolios/Jmcars'
import JarodPi from './components/pages/portfolios/JarodPi'
import Vactec from './components/pages/portfolios/Vactec'
import Safe from './components/pages/portfolios/Safe'
import Noraker from './components/pages/portfolios/Noraker'
import Allyon from './components/pages/portfolios/Allyon'
import Fineheart from './components/pages/portfolios/Fineheart'
import Ixxo from './components/pages/portfolios/Ixxo'
import Essae from './components/pages/portfolios/Essae'
import Aktid from './components/pages/portfolios/Aktid'
import Tetra from './components/pages/portfolios/Tetra'
import Newclip from './components/pages/portfolios/Newclip'
import Fnadepape from './components/pages/portfolios/Fnadepape'
import Synchro from './components/pages/portfolios/Synchro'
import Marjonat from './components/pages/portfolios/Marjonat'
import Appac from './components/pages/portfolios/Appac'
import Attax from './components/pages/portfolios/Attax'
import Igs from './components/pages/portfolios/Igs'
import Backbone from './components/pages/portfolios/Backbone'
import Tourdelisle from './components/pages/portfolios/Tourdelisle'
import Operagroupe from './components/pages/portfolios/Operagroupe'
import In2bones from './components/pages/portfolios/In2bones'
import Remedex from './components/pages/portfolios/Remedex'


Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [        
        { 
            path: '/',
            component: Home,
            meta: {
                title: 'SYNTHES\'3D WEB - Agence Web spécialisée dans la conception de site Internet',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SYNTHES\'3D WEB, filiale du groupe SYNTHES\'3D, est une Agence Web spécialisée en conception, design & développement de site Internet vitrine & Corporate, e-Commerce, application Web sur mesure ainsi qu’en référencement, SEO & WebMarketing.'
                  },
                  {
                    property: 'og:description',
                    content: 'SYNTHES\'3D WEB, filiale du groupe SYNTHES\'3D, est une Agence Web spécialisée en conception, design & développement de site Internet vitrine & Corporate, e-Commerce, application Web sur mesure ainsi qu’en référencement, SEO & WebMarketing.'
                  }
                ]
            },
        },
        { 
            path: '/solutions',
            component: Solutions,
            meta: {
                title: 'Les Solutions de notre Agence Web - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SYNTHES\'3D WEB propose des solutions pour répondre à vos besoins de site Internet Vitrine, boutique e-Commerce & Application Web sur mesure.'
                  },
                  {
                    property: 'og:description',
                    content: 'SYNTHES\'3D WEB propose des solutions pour répondre à vos besoins de site Internet Vitrine, boutique e-Commerce & Application Web sur mesure.'
                  }
                ]
            },
        },
        { 
            path: '/contact',
            component: Contact,
            meta: {
                title: 'Contactez notre Agence Web spécialisée dans la conception de site Internet - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SYNTHES\'3D WEB se tient à votre entière disposition pour échanger sur vos besoins et répondre à toutes vos questions concernant nos solutions.'
                  },
                  {
                    property: 'og:description',
                    content: 'SYNTHES\'3D WEB se tient à votre entière disposition pour échanger sur vos besoins et répondre à toutes vos questions concernant nos solutions.'
                  }
                ]
            },
        },
        { 
            path: '/portfolio',
            component: Portfolio,
            meta: {
                title: 'Le Portfolio de notre Agence Web - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SYNTHES\'3D WEB vous propose de découvrir le Portfolio de notre Agence Web, nos sites vitrine, e-Commerce & Application Web sur mesure.'
                  },
                  {
                    property: 'og:description',
                    content: 'SYNTHES\'3D WEB vous propose de découvrir le Portfolio de notre Agence Web, nos sites vitrine, e-Commerce & Application Web sur mesure.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/reucirs',
            component: Reucirs,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - REUCIRS - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'REUCIRS est un cabinet spécialisé dans l’accompagnement et le conseil en financement de la recherche et de l’innovation'
                  },
                  {
                    property: 'og:description',
                    content: 'REUCIRS est un cabinet spécialisé dans l’accompagnement et le conseil en financement de la recherche et de l’innovation'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/jmcars',
            component: Jmcars,
            meta: {
                title: 'Portfolio - Site Internet E-Commerce - JM CARS - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'JM CARS propose des expériences uniques afin que vous puissiez expérimenter l’art de vivre à la française.'
                  },
                  {
                    property: 'og:description',
                    content: 'JM CARS propose des expériences uniques afin que vous puissiez expérimenter l’art de vivre à la française.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/jarod-pi',
            component: JarodPi,
            meta: {
                title: 'Portfolio - Site Internet E-Commerce - JAROD-PI - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'Exclusivité et respect des êtres vivants, JAROD-PI représente la mode durable de demain. Des pièces limitées et numérotées, respectueuses de l\'environnement.'
                  },
                  {
                    property: 'og:description',
                    content: 'Exclusivité et respect des êtres vivants, JAROD-PI représente la mode durable de demain. Des pièces limitées et numérotées, respectueuses de l\'environnement.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/allyon',
            component: Allyon,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - ALLYON - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'ALLYON développe et vend des produits et solutions innovantes pour la chirurgie orthopédique et du rachis.'
                  },
                  {
                    property: 'og:description',
                    content: 'ALLYON développe et vend des produits et solutions innovantes pour la chirurgie orthopédique et du rachis.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/noraker',
            component: Noraker,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - NORAKER - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'NORAKER est spécialisée dans la conception, la fabrication et la commercialisation de dispositifs médicaux implantables à base de biomatériaux synthétiques et résorbables pour la substitution osseuse et l’ostéosynthèse.'
                  },
                  {
                    property: 'og:description',
                    content: 'NORAKER est spécialisée dans la conception, la fabrication et la commercialisation de dispositifs médicaux implantables à base de biomatériaux synthétiques et résorbables pour la substitution osseuse et l’ostéosynthèse.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/vactec',
            component: Vactec,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - VACTEC - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'VACTEC exploite et comercialise un système de protection incendie complet approuvé FM'
                  },
                  {
                    property: 'og:description',
                    content: 'VACTEC exploite et comercialise un système de protection incendie complet approuvé FM'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/aktid',
            component: Aktid,
            meta: {
                title: 'Portfolio - Application web sur mesure - AKTID - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'AKTID conçoit et réalise des solutions de tri et de valorisation de déchets clé en main.'
                  },
                  {
                    property: 'og:description',
                    content: 'AKTID conçoit et réalise des solutions de tri et de valorisation de déchets clé en main.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/essae',
            component: Essae,
            meta: {
                title: 'Portfolio - Site Internet E-Commerce - ESSAE - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'L\'Institut ESSAE propose des formations aux salariés et dirigeants afin d\'être bien dans sa vie professionnelle au quotidien.'
                  },
                  {
                    property: 'og:description',
                    content: 'L\'Institut ESSAE propose des formations aux salariés et dirigeants afin d\'être bien dans sa vie professionnelle au quotidien.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/fineheart',
            component: Fineheart,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - FINEHEART - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'FINEHEART a développé ICOMS: une thérapie révolutionnaire pour l’assistance circulatoire à long terme destinée aux patients souffrant d’insuffisance cardiaque grave.'
                  },
                  {
                    property: 'og:description',
                    content: 'FINEHEART a développé ICOMS: une thérapie révolutionnaire pour l’assistance circulatoire à long terme destinée aux patients souffrant d’insuffisance cardiaque grave.'
                  }
                ]
            },

        },
        { 
            path: '/portfolios/marjonat-distribution',
            component: Marjonat,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - MARJONAT DISTRIBUTION - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'MARJONAT DISTRIBUTION propose une solution de régie publicitaire implantée directement dans les magasins pour permettre aux annonceurs de communiquer directement aux shoppers.'
                  },
                  {
                    property: 'og:description',
                    content: 'MARJONAT DISTRIBUTION propose une solution de régie publicitaire implantée directement dans les magasins pour permettre aux annonceurs de communiquer directement aux shoppers.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/synchro-medical',
            component: Synchro,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - SYNCHROMEDICAL - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SYNCHROMEDICAL est une entreprise française qui conçoit et commercialise des dispositifs médicaux orthopédiques pour la chirurgie des extrémités.'
                  },
                  {
                    property: 'og:description',
                    content: 'SYNCHROMEDICAL est une entreprise française qui conçoit et commercialise des dispositifs médicaux orthopédiques pour la chirurgie des extrémités.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/tetra-medical',
            component: Tetra,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - TETRA MEDICAL - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'Le Laboratoire TETRA MEDICAL est un des acteurs majeurs de la fabrication et de la commercialisation de compresses, pansements et dispositifs médicaux à usage unique.'
                  },
                  {
                    property: 'og:description',
                    content: 'Le Laboratoire TETRA MEDICAL est un des acteurs majeurs de la fabrication et de la commercialisation de compresses, pansements et dispositifs médicaux à usage unique.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/newclip-technics',
            component: Newclip,
            meta: {
                title: 'Portfolio - Application web sur mesure - NEWCLIP TECHNICS - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'NEWCLIP TECHNICS conçoit, fabrique et commercialise des implants d’ostéosynthèse destinés à la chirurgie réglée ou à la traumatologie.'
                  },
                  {
                    property: 'og:description',
                    content: 'NEWCLIP TECHNICS conçoit, fabrique et commercialise des implants d’ostéosynthèse destinés à la chirurgie réglée ou à la traumatologie.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/fnadepape',
            component: Fnadepape,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - FNADEPAPE - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'La FNADEPAPE regroupe des Associations Départementales d’Entraide pour les pupilles de l\'Etat et les personnes admises à l’Aide Sociale à l’Enfance.'
                  },
                  {
                    property: 'og:description',
                    content: 'La FNADEPAPE regroupe des Associations Départementales d’Entraide pour les pupilles de l\'Etat et les personnes admises à l’Aide Sociale à l’Enfance.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/ixxo-wheel',
            component: Ixxo,
            meta: {
                title: 'Portfolio - Site Internet E-Commerce - IXXO WHEEL - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'IXXO WHEEL propose des produits afin de rendre le démontage et le remontage d\'une roue arrière ou avant de moto facile et rapide.'
                  },
                  {
                    property: 'og:description',
                    content: 'IXXO WHEEL propose des produits afin de rendre le démontage et le remontage d\'une roue arrière ou avant de moto facile et rapide.'
                  }
                ]
            },
        },
        { 
            path: '/portfolios/safe-orthopaedics',
            component: Safe,
            meta: {
                title: 'Portfolio - Site Internet Vitrine - SAFE ORTHOPAEDICS - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SAFE ORTHOPAEDICS développe des technologies pour optimiser tous les aspects de l’environnement de soins de santé actuel'
                  },
                  {
                    property: 'og:description',
                    content: 'SAFE ORTHOPAEDICS développe des technologies pour optimiser tous les aspects de l’environnement de soins de santé actuel'
                  }
                ]
            },
        },
        { 
          path: '/portfolios/appac',
          component: Appac,
          meta: {
              title: 'Portfolio - Site Internet Vitrine - APPAC - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'La plateforme de Webinars pour l\'APPAC présente une édition digitale d\'un congrès dont la version physique avait été annulée à cause de la Covid-19. Notre solution permet la gestion des vidéos de cet événement virtuel ainsi que la mesure de statistiques.'
                },
                {
                  property: 'og:description',
                  content: 'La plateforme de Webinars pour l\'APPAC présente une édition digitale d\'un congrès dont la version physique avait été annulée à cause de la Covid-19. Notre solution permet la gestion des vidéos de cet événement virtuel ainsi que la mesure de statistiques.'
                }
              ]
          },
        },
        { 
          path: '/portfolios/attax',
          component: Attax,
          meta: {
              title: 'Portfolio - Site Internet Vitrine - ATTAX - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'ATTAX est une société industrielle innovante spécialisée dans la conception et la production de systèmes de verrous pour l\'industrie aéronautique.'
                },
                {
                  property: 'og:description',
                  content: 'ATTAX est une société industrielle innovante spécialisée dans la conception et la production de systèmes de verrous pour l\'industrie aéronautique.'
                }
              ]
          },
        },
        { 
          path: '/portfolios/igs',
          component: Igs,
          meta: {
              title: 'Portfolio - Site Internet Vitrine - IGS - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'La plateforme IGS permet de créer et d\'assurer le suivi de formations. Elle se concentre sur l\'apprenant et son ressenti lors de la formation.'
                },
                {
                  property: 'og:description',
                  content: 'La plateforme IGS permet de créer et d\'assurer le suivi de formations. Elle se concentre sur l\'apprenant et son ressenti lors de la formation.'
                }
              ]
          },
          
        },
        { 
          path: '/portfolios/backbone',
          component: Backbone,
          meta: {
              title: 'Portfolio - Site Internet Vitrine - BACKBONE - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'BACKBONE conçoit, développe, fabrique et commercialise des dispositifs médicaux implantables pour la chirurgie du rachis.'
                },
                {
                  property: 'og:description',
                  content: 'BACKBONE conçoit, développe, fabrique et commercialise des dispositifs médicaux implantables pour la chirurgie du rachis.'
                }
              ]
          },
        },
        { 
          path: '/portfolios/tour-de-lisle',
          component: Tourdelisle,
          meta: {
              title: 'Portfolio - Site Internet Vitrine - Woocommerce - TOUR DE LISLE - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'TOUR DE L\'ISLE propose dans leur cave à vins de L’Isle sur la Sorgue, une gamme de vins authentique et homogène.'
                },
                {
                  property: 'og:description',
                  content: 'TOUR DE L\'ISLE propose dans leur cave à vins de L’Isle sur la Sorgue, une gamme de vins authentique et homogène.'
                }
              ]
          },
        },
        { 
          path: '/portfolios/opera-groupe',
          component: Operagroupe,
          meta: {
              title: 'Portfolio - Site Internet Vitrine - Module sur mesure - OPERA GROUPE - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'OPERA GROUPE réalise des états des lieux et diagnostics immobiliers pour les professionnels et les particuliers sur toute la France'
                },
                {
                  property: 'og:description',
                  content: 'OPERA GROUPE réalise des états des lieux et diagnostics immobiliers pour les professionnels et les particuliers sur toute la France'
                }
              ]
          },
        },
        { 
          path: '/portfolios/in2bones',
          component: In2bones,
          meta: {
              title: 'Portfolio - Site Internet Vitrine - IN2BONES - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'IN2BONES est pionner de l\'usage unique pour le pied et la cheville.'
                },
                {
                  property: 'og:description',
                  content: 'IN2BONES est pionner de l\'usage unique pour le pied et la cheville.'
                }
              ]
          },
        },
        { 
          path: '/portfolios/remedex',
          component: Remedex,
          meta: {
              title: 'Portfolio - Application sur mesure - REMEDEX - SYNTHES\'3D WEB',
              metaTags: [
                {
                  name: 'description',
                  content: 'La plateforme REMEDEX permet de suivre l\'évolution des pathologies des patients suite à des injections.'
                },
                {
                  property: 'og:description',
                  content: 'La plateforme REMEDEX permet de suivre l\'évolution des pathologies des patients suite à des injections.'
                }
              ]
          },
        },
        { 
            path: '/mentions-legales',
            component: Mentions,
            meta: {
                title: 'Mentions Légales de notre Agence Web - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SYNTHES\'3D WEB détaille ici ses mentions légales.'
                  },
                  {
                    property: 'og:description',
                    content: 'SYNTHES\'3D WEB détaille ici ses mentions légales.'
                  }
                ]
            },
        }, 
        { 
            path: '/services',
            component: Services,
            meta: {
                title: 'Les Services de notre Agence Web - SYNTHES\'3D WEB',
                metaTags: [
                  {
                    name: 'description',
                    content: 'SYNTHES\'3D WEB propose un panel complet de services pour répondre à vos besoins de maintenance & sécurité, de Webmarketing & SEO et de suivi d\'utilisation de votre site.'
                  },
                  {
                    property: 'og:description',
                    content: 'SYNTHES\'3D WEB propose un panel complet de services pour répondre à vos besoins de maintenance & sécurité, de Webmarketing & SEO et de suivi d\'utilisation de votre site.'
                  }
                ]
            },
        },
        {     
          path: '/prise_de_brief',
          component: PriseBrief
        }, 
        { path: '**', redirect: '/'}
    ],
    scrollBehavior (to, from, savedPosition) {
        if (to.hash) {
    //	return { selector: to.hash }
    return window.scrollTo({ top: document.querySelector(to.hash).offsetTop, behavior: 'smooth' });
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 }
        }
    },

})

router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  
    const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  
    if(nearestWithTitle) document.title = nearestWithTitle.meta.title;
  
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  
    if(!nearestWithMeta) return next();
  
    nearestWithMeta.meta.metaTags.map(tagDef => {
      const tag = document.createElement('meta');
  
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
  
      tag.setAttribute('data-vue-router-controlled', '');
  
      return tag;
    })
    .forEach(tag => document.head.appendChild(tag));
  
    next();
  });

export default router